import { render } from "./DettaglioFornitore.vue?vue&type=template&id=476d3c57&scoped=true&ts=true"
import script from "./DettaglioFornitore.vue?vue&type=script&lang=ts"
export * from "./DettaglioFornitore.vue?vue&type=script&lang=ts"

import "./DettaglioFornitore.vue?vue&type=style&index=0&id=476d3c57&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476d3c57"]])

export default __exports__